@use "variables" as *;
@use "./helpers/headerSectionStyles/headerSectionStyles.scss" as *;

.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 72px);
}

.container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 72px); // 72px is the height of the navigation
  padding-top: $spacing-2;
}

.headerContainer {
  @include container;
}

.innerHeaderContainer {
  @include max-content-width;
}

.nav {
  flex-shrink: 0;
  padding-top: $spacing-4;
  overflow-x: auto;
}

.scrollableArea {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100vw;
  position: relative;
  left: 50%;
  margin-left: -50vw;
  display: flex;
  flex-direction: column;
}

.articlesWrapper {
  padding: $spacing-2;

  @include on-bp(xl) {
    padding: $spacing-2 0;
  }
}

.innerArticlesWrapper {
  @include max-content-width;
}

.highlight {
  background-color: $highlight-color;
  color: $content-primary-color;
}

.footerWrapper {
  @include max-content-width;
  width: 100%;
  margin-top: auto;
  flex-shrink: 0;
  padding: 0 $spacing-2 $spacing-4;

  @include on-bp(xl) {
    padding: 0 0 $spacing-4;
  }
}
